import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useMemo, useState } from "react";
import { DateRangePicker } from "rsuite";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import LineChartReport from "./LineChartReport";
import {
  convertDateFormat,
  formatDashboardGraphDateLabel,
  getTodayDateBasedOnTimeZone,
  nFormatter,
  setDefaultMustFilters,
} from "app/utils/utils";

import Masonry from "@mui/lab/Masonry";
import { useSelector } from "react-redux";
import { dispatch } from "app/store/store";
import {
  GetDashboardPreInfoDataThunk,
  GetGraphAndSummaryDataThunk,
} from "app/store/slice/analytics-dashboard-slice";
import { unwrapResult } from "@reduxjs/toolkit";
import OmaxDashboardView from "./SupplyDashboard/OmaxDashboardView";
import {
  analyticeOrSupplyDashboardtilesSection,
  //analyticORSupplyDashboardGraphLabels,
  analyticORSupplyDashboardTiles,
  sortBysOptions,
  summary_options_ext,
} from "app/utils/constants/data";

import { preparePreDefinedProps } from "app/utils/utils";
import { useParams } from "react-router-dom";
import moment from "moment";
import uuid from "react-uuid";
const { combine, allowedMaxDays, beforeToday, before } = DateRangePicker;

const tableHeight = window.innerHeight - 135;

const AnalyticsDashboard = ({ profile_type, dashboardPreInfo }) => {
  //console.log("ProfileType 2:", profile_type);
  const { campaignIds } = useParams();

  // let todayDate = new Date();
  const {
    authUserData,
    globalCampaignsList,
    globalPublishersList,
    globalBiddersList,
  } = useSelector((state) => state.CommonReducer);

  const [todayDate, setTodayDate] = useState(
    authUserData?.report_timezone_country &&
      authUserData?.report_timezone_country != "" &&
      authUserData?.report_timezone_country != undefined
      ? getTodayDateBasedOnTimeZone(authUserData?.report_timezone_country)
      : new Date()
  );

  let dashboard_max_days =
    authUserData?.dashboard_max_days && authUserData?.dashboard_max_days > 0
      ? authUserData?.dashboard_max_days
      : 2;
  // const { dashboardPreInfo } = useSelector(
  //   (state) => state.AnalyticsDashboardReducer
  // );

  let campaignIdArr =
    campaignIds != "" && campaignIds != null ? campaignIds.split(",") : [];

  let preDefinedProps = useMemo(
    () =>
      preparePreDefinedProps(
        dashboardPreInfo,
        summary_options_ext,
        authUserData,
        profile_type
      ),
    [dashboardPreInfo]
  );

  const defaultMustFilters = useMemo(
    () =>
      setDefaultMustFilters(
        authUserData,
        profile_type,
        dashboardPreInfo,
        campaignIdArr,
        globalCampaignsList,
        globalPublishersList,
        globalBiddersList
      ),
    [authUserData, dashboardPreInfo]
  );

  const [dashboardFilters, setDashboardFilters] = useState({
    startdate: todayDate,
    enddate: todayDate,
    mustFilters: defaultMustFilters?.mustFilters
      ? defaultMustFilters?.mustFilters
      : {},
    mustNotFilters: {},
    sortBy: {
      label: "Impressions",
      value: "impressions",
    },
    filterBars: defaultMustFilters?.filterBars
      ? defaultMustFilters?.filterBars
      : {},
    randomId: uuid(),
  });

  // useEffect(() => {
  //   if (Object.keys(dashboardPreInfo).length > 0) {
  //     setDashboardFilters((prevState) => {
  //       return {
  //         ...prevState,
  //         mustFilters: defaultMustFilters?.mustFilters
  //           ? defaultMustFilters?.mustFilters
  //           : {},
  //         filterBars: defaultMustFilters?.filterBars
  //           ? defaultMustFilters?.filterBars
  //           : {},
  //       };
  //     });
  //   }
  // }, [defaultMustFilters]);

  //console.log("defaultMustFilters:", defaultMustFilters);

  //const [selectedDate, setSelectedDate] = useState([todayDate, todayDate]);
  const [summaryData, setSummaryData] = useState({});
  const [graphData, setGraphData] = useState([]);
  // const [sortBy, setSortBy] = useState({
  //   label: "Impressions",
  //   value: "impressions",
  // });
  const [graphType, setgraphType] = useState("DayHour");
  const [loader, setLoader] = useState(false);
  const [summaryLoader, setSummaryLoader] = useState(false);
  const [xAxislabel, setXAxisLabel] = useState("Day & Hour");

  useEffect(() => {
    if (Object.keys(dashboardPreInfo).length > 0) {
      getGraphData(graphType);
      getSummaryData();
    }
  }, [dashboardFilters]);

  const handleDateChange = (date) => {
    if (date !== null) {
      //setSelectedDate([date[0], date[1]]);
      setDashboardFilters((prevState) => {
        return {
          ...prevState,
          startdate: date[0],
          enddate: date[1],
        };
      });
    }
  };
  const graphChangeHandler = (event) => {
    setXAxisLabel(event.target.value == "DayHour" ? "Day & Hour" : "Days");
    setgraphType(event.target.value);
    getGraphData(event.target.value);
  };

  const handleAccordionChange = (panel) => (event, isExpanded) => {
    if (isExpanded) {
      getGraphData(graphType);
    }
  };

  const getGraphData = (type) => {
    let payload = {
      dataview: profile_type,
      userData: {
        is_sys_admin: authUserData.is_sys_admin,
        user_id: authUserData.user_id,
      },
      grid: type,
      gridType: "SIMPLE",
      startdate: convertDateFormat(dashboardFilters.startdate, "MM/DD/YY"),
      enddate: convertDateFormat(dashboardFilters.enddate, "MM/DD/YY"),
      must: dashboardFilters.mustFilters,
      mustNot: dashboardFilters.mustNotFilters,
      size: 1000,
      aggs: Object.keys(preDefinedProps.graphs),
      aggsort: type,
      ssptraffic: "all",
      traffic: "all",
    };
    setLoader(true);
    dispatch(GetGraphAndSummaryDataThunk(payload))
      .then(unwrapResult)
      .then((res) => {
        if (res?.data?.results?.data.length > 0) {
          let resultData = res?.data?.results?.data;
          if (type == "DayHour") {
            resultData.map((info) => {
              let dayHour = info.DayHour.split(" ");
              let monthDate = formatDashboardGraphDateLabel(dayHour[0]);
              info.DayHour = monthDate + " " + dayHour[1] + ":00";
            });
          } else {
            resultData.map((info) => {
              let day = info.Day;
              let monthDate = formatDashboardGraphDateLabel(day);

              info.Day = monthDate;
            });
          }

          setGraphData(resultData);
        } else {
          setGraphData([]);
        }
        setLoader(false);
      });
  };

  const getSummaryData = () => {
    let payload = {
      summary: preDefinedProps.showsummaryfilters,
      startdate: convertDateFormat(dashboardFilters.startdate, "MM/DD/YY"),
      enddate: convertDateFormat(dashboardFilters.enddate, "MM/DD/YY"),
      must: dashboardFilters.mustFilters,
      mustNot: dashboardFilters.mustNotFilters,
      ssptraffic: "all",
      traffic: "all",
      dataview: profile_type,
      userData: {
        is_sys_admin: authUserData.is_sys_admin,
        user_id: authUserData.user_id,
      },
    };
    setSummaryLoader(true);
    dispatch(GetGraphAndSummaryDataThunk(payload))
      .then(unwrapResult)
      .then((res) => {
        //console.log("tilesData", res?.data?.results?.data);
        let resultData = res?.data?.results?.data;
        if (Object.keys(resultData).length > 0) {
          setSummaryData(res?.data?.results?.data);
        } else {
          setSummaryData({});
        }
        setSummaryLoader(false);
      });
  };

  const submitHandler = () => {
    //setLoader(true);
    // getGraphData(graphType);
    // getSummaryData();

    setDashboardFilters((prevState) => {
      return {
        ...prevState,
        randomId: uuid(),
      };
    });
  };

  // const getDashboardPreInfo = (type) => {
  //   let payload = {
  //     dataview: profile_type,
  //     userData: {
  //       is_sys_admin: authUserData.is_sys_admin,
  //       user_id: authUserData.user_id,
  //       show_publisher_tile: false,
  //     },
  //   };

  //   dispatch(GetDashboardPreInfoDataThunk(payload))
  //     .then(unwrapResult)
  //     .then((res) => {});
  // };

  // useEffect(() => {
  //   getDashboardPreInfo();
  // }, []);

  // console.log(
  //   "analyticORSupplyDashboardTiles:",
  //   analyticORSupplyDashboardTiles
  // );

  return (
    <>
      {Object.keys(dashboardPreInfo).length <= 0 && (
        <Box sx={{ position: "relative" }}>
          <CircularProgress
            sx={{
              zIndex: 4,
              position: "absolute",
              top: (window.innerHeight - 130) / 2 + "px",
              left: "50%",
              transform: "translate(-50%, -50%)",
              transform: "-webkit-translate(-50%, -50%)",
              transform: "-moz-translate(-50%, -50%)",
              transform: "-ms-translate(-50%, -50%)",
            }}
          />
        </Box>
      )}

      {Object.keys(dashboardPreInfo).length > 0 && (
        <Card sx={{ p: 1, height: "calc(100vh - 90px)", overflow: "auto", mt: 0.25 }}>
          <Card sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={5} md={5} sx={{ mt: 1 }}>
                <DateRangePicker
                  placeholder="Select Date Range"
                  placement={"bottomEnd"}
                  appearance={"subtle"}
                  format="yyyy-MM-dd"
                  value={[dashboardFilters.startdate, dashboardFilters.enddate]}
                  cleanable={false}
                  ranges={[]}
                  style={{
                    border: "none",
                    borderBottom: "2px solid #ccc",
                    width: "100%",
                    //marginTop: "10px",
                  }}
                  onChange={handleDateChange}
                  disabledDate={before(
                    moment()
                      .subtract(dashboard_max_days - 1, "days")
                      .toDate()
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={5} md={5}>
                <Autocomplete
                  id="SortBy"
                  name="SortBy"
                  options={sortBysOptions ? sortBysOptions : []}
                  filterSelectedOptions
                  getOptionLabel={(option) =>
                    option.label ? option.label : ""
                  }
                  isOptionEqualToValue={(option, value) =>
                    option.value === value.value
                  }
                  disableClearable={true}
                  value={dashboardFilters.sortBy}
                  renderOption={(props, option) => (
                    <li key={option.value} {...props}>
                      {option.label}
                    </li>
                  )}
                  onChange={(e, newValue) => {
                    // setSortBy(newValue);
                    setDashboardFilters((prevState) => {
                      return {
                        ...prevState,
                        sortBy: newValue,
                      };
                    });
                  }}
                  ListboxProps={{
                    style: {
                      maxHeight: "150px",
                    },
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      id="SortBy"
                      name="SortBy"
                      label="Sort By"
                      variant="standard"
                      placeholder="Select Organization"
                      fullWidth
                      sx={{ mb: 1 }}
                      autoComplete="off"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={2} md={2} sx={{ mt: 1 }}>
                <Button variant="contained" onClick={submitHandler}>
                  Go
                </Button>
              </Grid>
            </Grid>
          </Card>

          <Accordion
            sx={{ mt: 1, borderRadius: "4px" }}
            onChange={handleAccordionChange()}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderBottom: "1px solid #ccc" }}
            >
              <Typography>
                Quick View
                {defaultMustFilters?.campaignLabel != ""
                  ? " : " + defaultMustFilters?.campaignLabel
                  : " (Graph)"}{" "}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ height: "500px", p: 2 }}>
              {loader && (
                <Box sx={{ position: "relative" }}>
                  <CircularProgress
                    sx={{
                      zIndex: 4,
                      position: "absolute",
                      top: 400 / 3 + "px",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      transform: "-webkit-translate(-50%, -50%)",
                      transform: "-moz-translate(-50%, -50%)",
                      transform: "-ms-translate(-50%, -50%)",
                    }}
                  />
                </Box>
              )}
              <Box sx={{ textAlign: "center" }}>Graph View</Box>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <FormControl>
                  <RadioGroup
                    row
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={graphType}
                    onChange={graphChangeHandler}
                  >
                    <FormControlLabel
                      value="Day"
                      control={<Radio />}
                      label="Daily"
                    />
                    <FormControlLabel
                      value="DayHour"
                      control={<Radio />}
                      label="Hourly"
                    />
                  </RadioGroup>
                </FormControl>
              </Box>

              <Box>
                <LineChartReport
                  labels={preDefinedProps.graphs}
                  xAxislabel={xAxislabel}
                  yAxislabel="Metrics"
                  graphType={graphType}
                  graphData={graphData}
                />
              </Box>
            </AccordionDetails>
          </Accordion>
          <Accordion sx={{ mt: 1, borderRadius: "4px", display: "none" }}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderBottom: "1px solid #ccc" }}
            >
              <Typography>Presets</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Box sx={{ p: 2, mt: 3, textAlign: "center", color: "red" }}>
                There are no presets.
              </Box>
            </AccordionDetails>
          </Accordion>

          <Accordion
            sx={{
              mt: 1,
              borderRadius: "4px",
              ".MuiCollapse-wrapperInner": { p: { sm: 0, md: 2 } },
            }}
            expanded={true}
          >
            <AccordionSummary
              aria-controls="panel1a-content"
              id="panel1a-header"
              sx={{ borderBottom: "1px solid #ccc", pointerEvents: "none" }}
            >
              <Typography>
                Analytics{" "}
                {defaultMustFilters?.campaignLabel != ""
                  ? " : " + defaultMustFilters?.campaignLabel
                  : ""}{" "}
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ p: 0 }}>
              <Box sx={{ p: 2, width: "100%" }} id="summary_div_cls">
                <Masonry columns={4} spacing={1}>
                  {Object.keys(analyticORSupplyDashboardTiles).map(
                    (groupKey, i) => {
                      let tilesInfo = analyticORSupplyDashboardTiles[groupKey];

                      tilesInfo = Object.keys(
                        preDefinedProps.summary_options_ext
                      )
                        .filter(
                          (itemKey) =>
                            preDefinedProps.summary_options_ext[itemKey]
                              .ui_group_id == groupKey
                        )
                        .map((itemKey) => {
                          return {
                            key: itemKey,
                            ...preDefinedProps.summary_options_ext[itemKey],
                          };
                        });
                      //console.log("groupKey:", i);

                      return (
                        <fieldset
                          key={groupKey}
                          style={{
                            float: i == "1" || i == "3" ? "right" : "left",
                            width: i == "1" || i == "3" ? "49%" : "50%",
                          }}
                        >
                          <legend
                            style={{
                              paddingLeft: "10px",
                              paddingRight: "10px",
                            }}
                          >
                            {
                              analyticeOrSupplyDashboardtilesSection[groupKey]
                                .name
                            }
                          </legend>

                          {tilesInfo.map((info, n) => {
                            return (
                              <Box
                                className="sum_stl"
                                key={`${groupKey}-${info.key}`}
                              >
                                <Box className="sdf">
                                  <h5 style={{ margin: "0px" }}>
                                    {info?.prefix}

                                    {summaryLoader ? (
                                      <CircularProgress size={15} />
                                    ) : summaryData[info.key] > 0 &&
                                      summaryData[info.key] < 1 ? (
                                      summaryData[info.key]
                                    ) : (
                                      nFormatter(summaryData[info.key], 2)
                                    )}
                                  </h5>
                                  <Box
                                    className="summary_label"
                                    sx={{
                                      background:
                                        analyticeOrSupplyDashboardtilesSection[
                                          groupKey
                                        ].label_color,
                                      color:
                                        analyticeOrSupplyDashboardtilesSection[
                                          groupKey
                                        ].font_color,
                                    }}
                                  >
                                    {info.label}
                                  </Box>
                                </Box>
                              </Box>
                            );
                          })}
                        </fieldset>
                      );
                    }
                  )}
                </Masonry>
              </Box>

              <Card sx={{ p: 2, mt: 2 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12} md={12} sx={{ mt: 1 }}>
                    <OmaxDashboardView
                      //selectedDate={selectedDate}
                      dashboardFilters={dashboardFilters}
                      setDashboardFilters={setDashboardFilters}
                      //sortBy={sortBy}
                      gridSelection={dashboardPreInfo.gridSelection}
                      preDefinedProps={preDefinedProps}
                      profile_type={profile_type}
                    />
                  </Grid>
                </Grid>
              </Card>
            </AccordionDetails>
          </Accordion>
        </Card>
      )}
    </>
  );
};

export default AnalyticsDashboard;
